"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerConfig = exports.VersionRelease = void 0;
const property_1 = require("../../decorators/property");
const mocks_1 = require("../../mocks");
const class_validator_1 = require("class-validator");
const conference_1 = require("../conference/conference");
const banner_1 = require("./banner");
const class_transformer_1 = require("class-transformer");
class VersionRelease {
}
exports.VersionRelease = VersionRelease;
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, property_1.Property)(),
    __metadata("design:type", Boolean)
], VersionRelease.prototype, "forceUpdate", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], VersionRelease.prototype, "versionCode", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], VersionRelease.prototype, "downloadLink", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], VersionRelease.prototype, "changeLog", void 0);
class ServerConfig extends mocks_1.Model {
}
exports.ServerConfig = ServerConfig;
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => conference_1.IceServer),
    (0, property_1.Property)({ type: () => [conference_1.IceServer] }),
    __metadata("design:type", Array)
], ServerConfig.prototype, "iceServers", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], ServerConfig.prototype, "tac", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], ServerConfig.prototype, "retryThreshold", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], ServerConfig.prototype, "iceTransportPolicy", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, property_1.Property)(),
    __metadata("design:type", Boolean)
], ServerConfig.prototype, "trickleIce", void 0);
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    (0, property_1.Property)({ type: [String], default: [] }),
    __metadata("design:type", Array)
], ServerConfig.prototype, "notificationsOnNewVisit", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], ServerConfig.prototype, "conferencePingTimeout", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], ServerConfig.prototype, "supportPhoneNumber", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => VersionRelease),
    (0, property_1.Property)({ type: () => VersionRelease }),
    __metadata("design:type", VersionRelease)
], ServerConfig.prototype, "android", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => VersionRelease),
    (0, property_1.Property)({ type: () => VersionRelease }),
    __metadata("design:type", VersionRelease)
], ServerConfig.prototype, "ios", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => banner_1.Banner),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, property_1.Property)({ type: () => [banner_1.Banner], default: [] }),
    __metadata("design:type", Array)
], ServerConfig.prototype, "patientBanners", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => banner_1.Banner),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, property_1.Property)({ type: () => [banner_1.Banner], default: [] }),
    __metadata("design:type", Array)
], ServerConfig.prototype, "doctorBanners", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)({ default: 50 }),
    __metadata("design:type", Number)
], ServerConfig.prototype, "maxVideoSizeMb", void 0);
